import React, { useEffect } from "react";
import { action, useDsp } from "app/store";
import { SectionProfilePerformer } from "blocks/profile";

export const WrapperProfilePerformer = () => {
  const dispatch = useDsp();

  useEffect(() => {
    dispatch(action.loaderProfilePrfSet(false));
  }, []);

  return <SectionProfilePerformer />;
};
